<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->

          <!-- Search -->

          <b-col cols="12" lg="8">
            <b-row class="align-items-center">
              <b-col lg="6" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    id="search"
                    autocomplete="search"
                    v-model.trim="searchQuery"
                    @keyup.enter="onSearch()"
                    class="d-inline-block round"
                    :placeholder="$t('textPlaceholderSearchLocation')"
                  />
                </div>
              </b-col>
              <b-col
                cols="12"
                md="4"
                lg="4"
                class="d-flex align-items-center justify-content-center justify-content-lg-start p-0 my-1 m-lg-0"
              >
                <b-button
                  class="round px-5 mr-1"
                  variant="primary"
                  :disabled="isBtnSearch"
                  @click="onSearch"
                >
                  {{ $t("search") }}
                </b-button>
                <feather-icon
                  @click="filter = !filter"
                  class="btn-icon"
                  :class="{ 'filter-active': filter }"
                  width="25"
                  height="25"
                  icon="FilterIcon"
                />
                <b-button
                  variant="primary"
                  class="round ml-1"
                  @click="onExportExcel()"
                >
                  Export Excel
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            cols="12"
            lg="4"
            class="d-flex align-items-center justify-content-end justify-content-xs-start mb-md-0"
            v-if="userData.role == 'ADMIN'"
          >
            <b-button variant="primary" class="round" @click="New()">
              {{ $t("addNewUser") }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-1" v-show="filter">
          <b-col lg="6">
            <div
              class="d-flex align-items-center justify-content-end mt-1 m-lg-0"
            >
              <Select4
                v-model="searchCompany"
                classProp="search round"
                placeholder="Select Company"
                :options="{
                  isSearch: true,
                  value: 'name',
                  label: 'text',
                  all: true,
                  data: companyItems,
                  fields: [
                    { field: 'code', label: 'Tax Code' },

                    { field: 'name', label: 'Name' },
                    {
                      field: 'acronym',
                      label: 'Acronym',
                    },
                  ],
                }"
              />
            </div>
          </b-col>
          <b-col lg="6">
            <div
              class="d-flex align-items-center justify-content-end mt-1 m-lg-0"
            >
              <!-- <multiselect
                label="name"
                class="search round"
                :searchable="true"
                :show-labels="false"
                :placeholder="$t('chooseSaler')"
                v-model="searchSaler"
                :options="sales"
              /> -->
              <Select4
                v-model="searchSaler"
                :options="{
                  isSearch: true,
                  value: 'id',
                  all: true,
                  label: 'text',
                  data: sales,
                  fields: [{ field: 'name', label: 'name' }],
                }"
              />
            </div> </b-col
        ></b-row>
      </div>
      <b-table
        responsive
        hover
        :items="items"
        fixed
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(user_sale_name)="row">
          {{
            row.item.user_sale_name
              ? row.item.user_sale_name.replaceAll(",", ", ")
              : "N/A"
          }}
        </template>
        <template #cell(sale_name)="row">
          {{ row.item.sale_name ? row.item.sale_name : "N/A" }}
        </template>
        <template #cell(actions)="row">
          <div class="d-flex justify-content-center gap-10">
            <!-- <b-button
              v-b-tooltip.hover.top="$t('updateRole')"
              variant="primary"
              size="sm"
              @click="Permission(row.item, row.index, $event.target)"
            >
              <feather-icon icon="UserCheckIcon" />
            </b-button> -->
            <div class="d-flex flex-column gap-10">
              <b-button
                v-b-tooltip.hover.top="$t('changePassword')"
                variant="primary"
                size="sm"
                @click="ChangePas(row.item, row.index, $event.target)"
              >
                <feather-icon icon="KeyIcon" />
              </b-button>
              <b-button
                v-b-tooltip.hover.top="$t('Lock')"
                :variant="row.item.status_id == 1 ? 'primary' : 'warning'"
                size="sm"
                @click="lockUser(row.item, row.index, $event.target)"
              >
                <feather-icon
                  :icon="row.item.status_id == 1 ? 'LockIcon' : 'UnlockIcon'"
                />
              </b-button>
            </div>
            <div class="d-flex flex-column gap-10">
              <b-button
                v-b-tooltip.hover.top="'Update User'"
                variant="primary"
                size="sm"
                @click="Edit(row.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                v-b-tooltip.hover.top="'Delete user '"
                variant="danger"
                size="sm"
                @click="Delete(row.item, row.index, $event.target)"
              >
                <feather-icon icon="DeleteIcon" />
              </b-button>
            </div>
          </div>
        </template>
      </b-table>
      <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t("showing") }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            style="min-width: 60px"
            class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
          />
          <label>{{ $t("entries") }}</label>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      id="modal-permission"
      scrollable
      body-class="p-0"
      :title="$t('updateRoleForUser')"
      @ok="handPermission"
    >
      <b-table responsive="sm" hover :items="permisItems" :fields="perFields">
        <template #cell(name)="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>
        <template #cell(C)="row">
          <b-form-checkbox v-model="row.item.C" />
        </template>
        <template #cell(R)="row">
          <b-form-checkbox v-model="row.item.R" />
        </template>
        <template #cell(U)="row">
          <b-form-checkbox v-model="row.item.U" />
        </template>
        <template #cell(D)="row">
          <b-form-checkbox v-model="row.item.D" />
        </template>
      </b-table>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-permission')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handPermission"
          class="btn round"
        >
          {{ $t("update") }}
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-edit"
      no-close-on-backdrop
      size="lg"
      :title="modal_title"
      @ok="handleOk"
    >
      <validation-observer ref="simpleRules">
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <label>{{ $t("userName") }} </label>
              <b-form-input
                disabled
                v-model="currentItem.IDLogin"
                placeholder="Username"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group>
                <label>
                  {{ $t("contactName") }}<span class="required">*</span>
                </label>

                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.fullName"
                  :placeholder="$t('contactName')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <validation-provider
              name="Company name"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label
                  >{{ $t("companyName") }}<span class="required">*</span>
                </label>
                <Select4
                  v-model="currentItem.company_name"
                  :classProp="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Company"
                  @select="onSelectCompany"
                  :options="{
                    isSearch: true,
                    value: 'name',
                    label: 'text',
                    all: true,
                    data: companyItems,
                    fields: [
                      { field: 'code', label: 'Tax Code' },

                      { field: 'name', label: 'Name' },
                      {
                        field: 'acronym',
                        label: 'Acronym',
                      },
                    ],
                  }"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <validation-provider
              name="Phone"
              #default="{ errors }"
              rules="required|regex:^([0-9]+)$"
            >
              <b-form-group>
                <label>
                  {{ $t("phone") }}<span class="required">*</span>
                </label>

                <b-form-input
                  v-model="currentItem.phone"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Phone"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider
              name="Email"
              #default="{ errors }"
              rules="email"
            >
              <b-form-group>
                <label>{{ $t("email") }}<span class="required">*</span> </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.email"
                  :placeholder="$t('email')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <validation-provider
              :name="$t('Customer Level')"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label
                  >{{ $t("Customer Level") }}<span class="required">* </span>
                </label>

                <Select4
                  v-model="currentItem.customerLevelId"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Customer Level"
                  :options="{
                    value: 'name',
                    label: 'text',
                    all: true,
                    data: vip_types,
                    fields: [
                      { field: 'name', label: 'Name' },
                      { field: 'description', label: 'Description' },
                    ],
                  }"
                />

                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="3">
            <b-form-group>
              <label>{{ $t("gender") }}<span class="required">*</span> </label>

              <b-row class="pw-1">
                <b-col cols="4">
                  <b-form-radio
                    v-model="currentItem.gender_id"
                    name="some-radios"
                    value="1"
                  >
                    {{ $t("Male") }}
                  </b-form-radio>
                </b-col>
                <b-col cols="4">
                  <b-form-radio
                    v-model="currentItem.gender_id"
                    name="some-radios"
                    value="2"
                  >
                    {{ $t("Female") }}
                  </b-form-radio>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <validation-provider
              name="FAST ID"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label> FAST ID <span class="required">*</span></label>
                <b-form-input
                  v-model="currentItem.idFast"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('enterIdFast')"
                />
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="3">
            <validation-provider
              name="TMS ID"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label> TMS ID<span class="required">*</span></label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.idTms"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <label>{{ $t("passport") }}</label>

              <b-form-input
                v-model="currentItem.idCard"
                :placeholder="$t('passport')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <validation-provider
              name="TMS Vendor ID"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>Vendor ID<span class="required">*</span></label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.tmsVendorId"
                />
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="3">
            <b-form-group>
              <label>{{ $t("userRoot") }}</label>

              <b-form-input
                disabled
                :value="currentItem.userRoot == 1 ? 'Yes' : 'No'"
                :placeholder="$t('enterUserRoot')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <validation-provider
              name="Wr1 staff"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label>Wr1 staff <span class="required">*</span> </label>
                <div class="d-flex">
                  <b-button
                    @click="editService"
                    variant="gradient-success"
                    class="btn-icon mr-1 text-white"
                  >
                    <feather-icon icon="UserPlusIcon" />
                  </b-button>

                  <SelectMultiple
                    :disabled="true"
                    v-model="currentItem.saler"
                    :options="{
                      value: 'code',
                      all: true,
                      data: sales,
                      multiple: true,
                      allowClear: true,
                    }"
                  />
                  <!-- <multiselect
                    v-model="currentItem.saler"
                    :disabled="true"
                    :multiple="true"
                    :options="sales"
                    :searchable="true"
                    :class="{ 'has-error': errors[0] }"
                    :show-labels="false"
                    :placeholder="$t('salesman')"
                    label="text"
                    track-by="text"
                  >
                  </multiselect> -->
                </div>

                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row> </b-row>
        <b-row>
          <b-col cols="6">
            <validation-provider #default="{ errors }" rules="regex:^([0-9]+)$">
              <b-form-group>
                <label> {{ $t("bankAccount") }} </label>
                <b-form-input
                  v-model="currentItem.bankAccount"
                  :state="errors.length > 0 ? false : null"
                  placeholder="8888 8888 8888 8888"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <label> {{ $t("bankName") }} </label>

              <!-- <multiselect
                v-model="bankName"
                :options="banks"
                :searchable="true"
                :show-labels="false"
                :placeholder="$t('selectBank')"
                label="text"
              >
              </multiselect> -->
              <Select4
                v-model="bankName"
                placeholder="Select VIP"
                :options="{
                  value: 'name',
                  label: 'text',
                  all: true,
                  data: banks,
                  fields: [
                    { field: 'code', label: 'CODE' },

                    { field: 'name', label: 'Name' },
                  ],
                }"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <label>{{ $t("dateRegister") }}</label>
              <b-form-input
                disabled
                v-model="currentItem.dateRegister"
                :placeholder="$t('dateRegisterEnter')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <label>{{ $t("approvedDate") }}</label>
              <b-form-input
                disabled
                v-model="currentItem.dateApproved"
                :placeholder="$t('approvedDateEnter')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group
              style="display: inline-block; position: relative; width: 100%"
            >
              <label>{{ $t("User List") }}</label>
              <b-form-input
                disabled
                class="input-href"
                :value="formatUser(currentItem.totalUser)"
                :placeholder="$t('userListEnter')"
              />
              <div
                @click="
                  currentItem.totalUser > 0
                    ? $router.push({
                        name: 'user-list',
                        params: {
                          idUser: currentItem.IDLogin,
                        },
                      })
                    : ''
                "
                style="
                  position: absolute;
                  left: 0;
                  right: 0;
                  top: 0;
                  bottom: 0;
                  cursor: pointer;
                "
              ></div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              style="display: inline-block; position: relative; width: 100%"
            >
              <label>{{ $t("Location") }}</label>
              <b-form-input
                disabled
                class="input-href"
                :value="formatLocation(currentItem.totalLocation)"
                :placeholder="$t('chooseListLocation')"
              />

              <div
                @click="
                  currentItem.totalLocation > 0
                    ? $router.push({
                        name: 'location',
                        params: {
                          idUser: currentItem.IDLogin,
                        },
                      })
                    : ''
                "
                style="
                  position: absolute;
                  left: 0;
                  right: 0;
                  top: 0;
                  bottom: 0;
                  cursor: pointer;
                "
              ></div>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="round"
          @click="$bvModal.hide('modal-edit')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handleOk"
          class="round"
          :disabled="isLoading"
        >
          {{ isLoading ? "Loading..." : "Updated" }}
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-pass"
      scrollable
      :title="$t('changePassword')"
      @ok="handChangePass"
    >
      <validation-observer ref="simpleRulesChangePass">
        <!-- <validation-provider #default="{ errors }" rules="required">
        <b-form-group label="Mật khẩu hiện tại" >
          <b-form-input type="password" :state="errors.length > 0 ? false:null" v-model="changepass.old" placeholder="Mật khẩu hiện tại"/>
        </b-form-group>
      </validation-provider> -->
        <validation-provider
          :name="$t('newPassword')"
          #default="{ errors }"
          rules="required"
        >
          <b-form-group>
            <label
              >{{ $t("newPassword") }}<span class="required">*</span>
            </label>

            <b-form-input
              id="idPass"
              type="password"
              :state="errors.length > 0 ? false : null"
              v-model="changepass.newPass"
              autocomplete="new-password"
              :placeholder="$t('newPassword')"
            />
            <small v-show="errors.length" class="text-danger">{{
              errors[0]
            }}</small>
          </b-form-group>
        </validation-provider>
        <validation-provider
          :name="$t('ReEnterNewPassword')"
          #default="{ errors }"
          rules="required"
        >
          <b-form-group>
            <label
              >{{ $t("ReEnterNewPassword") }}<span class="required">*</span>
            </label>

            <b-form-input
              type="password"
              :state="errors.length > 0 ? false : null"
              v-model="changepass.retype"
              :placeholder="$t('ReEnterNewPassword')"
            />
            <small v-show="errors.length" class="text-danger">{{
              errors[0]
            }}</small>
          </b-form-group>
        </validation-provider>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-pass')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handChangePass"
          class="btn round"
        >
          {{ $t("update") }}
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-add"
      size="xl"
      no-close-on-backdrop
      :title="modal_title"
      @ok="handleOkAdd"
    >
      <validation-observer ref="simpleRulesAdd">
        <b-row>
          <b-col cols="4">
            <validation-provider
              :name="$t('contactName')"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label
                  >{{ $t("contactName") }}<span class="required">*</span>
                </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="fullName"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <validation-provider
              :name="$t('Customer Level')"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label
                  >{{ $t("Customer Level") }}<span class="required">* </span>
                </label>

                <Select4
                  v-model="customerLevelId"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Customer Level"
                  :options="{
                    value: 'name',
                    label: 'text',
                    all: true,
                    data: vip_types,
                    fields: [
                      { field: 'name', label: 'Name' },
                      { field: 'description', label: 'Description' },
                    ],
                  }"
                />

                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label>{{ $t("gender") }}<span class="required">*</span> </label>
              <b-row class="pw-1">
                <b-col cols="4">
                  <b-form-radio v-model="gender" name="some-radios" value="1">
                    {{ $t("Male") }}
                  </b-form-radio>
                </b-col>
                <b-col cols="4">
                  <b-form-radio v-model="gender" name="some-radios" value="2">
                    {{ $t("Female") }}
                  </b-form-radio>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <validation-provider
              :name="$t('email')"
              #default="{ errors }"
              rules="required|email"
            >
              <b-form-group>
                <label>{{ $t("email") }}<span class="required">*</span> </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="contactEmail"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider
              :name="$t('phone')"
              #default="{ errors }"
              rules="required|regex:^([0-9]+)$"
            >
              <b-form-group>
                <label>{{ $t("phone") }}<span class="required">*</span> </label>

                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="mobile"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <validation-provider
              :name="$t('companyName')"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group>
                <label
                  >{{ $t("companyName") }}<span class="required">*</span>
                </label>

                <Select4
                  v-model="company"
                  :classProp="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Company"
                  :options="{
                    isSearch: true,
                    value: 'name',
                    label: 'text',
                    all: true,
                    data: companyItems,
                    fields: [
                      { field: 'code', label: 'Tax Code' },

                      { field: 'name', label: 'Name' },
                      {
                        field: 'acronym',
                        label: 'Acronym',
                      },
                    ],
                  }"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <div v-if="modal_title == $t('updateUserInformation')">
          <b-row>
            <b-col cols="6">
              <validation-provider
                :name="$t('userName')"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ $t("userName") }}<span class="required">*</span>
                  </label>

                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="userId"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                :name="$t('passport')"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ $t("passport") }}<span class="required">*</span>
                  </label>

                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="passport"
                    placeholder="Enter Identity card/Passport"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <validation-provider
                :name="$t('bankAccount')"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ $t("bankAccount") }}<span class="required">*</span>
                  </label>

                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="bankAccount"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                :name="$t('bankName')"
                #default="{ errors }"
                :rules="{ required: 'required', vselect: true }"
              >
                <b-form-group>
                  <label
                    >{{ $t("bankName") }}<span class="required">*</span>
                  </label>

                  <multiselect
                    v-model="bankName"
                    :options="banks"
                    :class="{ 'has-error': errors[0] }"
                    :state="errors.length > 0 ? false : null"
                    :searchable="true"
                    :show-labels="false"
                    :placeholder="$t('enterSelect')"
                    label="text"
                    track-by="text"
                  >
                  </multiselect>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group :label="$t('registrationsDate')">
                <b-form-input disabled v-model="registrationsDate" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group :label="$t('approvedDate')">
                <b-form-input disabled v-model="approvedDate" />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-add')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handleOkAdd"
          class="btn round"
        >
          {{
            modal_title == $t("updateUserInformation")
              ? $t("update")
              : $t("add")
          }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-add-sale"
      size="lg"
      no-close-on-backdrop
      title="Edit Service"
      @ok="handleOk"
    >
      <h5 class="my-1 font-weight-bold card-text text-primary">
        Chọn loại hình dịch vụ để gán sale cho khách hàng
      </h5>
      <b-row>
        <b-col cols="12">
          <div class="float-left">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none p-0 mb-1 text-primary"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  @click="$bvModal.show('modal-add-sale')"
                  variant="gradient-success"
                  class="btn-icon mr-1 text-white"
                >
                  <feather-icon icon="PlusIcon" /> Add Service
                </b-button>
              </template>
              <b-dropdown-item
                @click="services.push(i)"
                :key="i.id"
                v-for="i in service_types.filter(
                  (i) => services.filter((j) => j.id === i.id).length == 0
                )"
              >
                <feather-icon icon="FolderIcon" class="mr-50" />
                <span>{{ i.name }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </b-col>
        <b-col class="col-12">
          <b-row>
            <b-col v-for="(item, index) in services" :key="index" cols="12">
              <b-form-group>
                <label>{{ item.name }}</label>
                <!-- <multiselect
                  :ref="camelCaseText(item.name)"
                  :multiple="true"
                  placeholder="Select Saler"
                  v-model="serviceUserID[item.id]"
                  :options="sales"
                  label="text"
                  track-by="id"
                  :searchable="true"
                  :show-labels="false"
                /> -->
                <SelectMultiple
                  :ref="camelCaseText(item.name)"
                  v-model="serviceUserID[item.id]"
                  :options="{
                    value: 'id',
                    all: true,
                    data: sales,
                    multiple: true,
                    allowClear: true,
                  }"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="round"
          @click="$bvModal.hide('modal-add-sale')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handleOkEditSale"
          class="round"
        >
          {{ $t("approved") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import vSelect from "vue-select";
import { camelCase, map } from "lodash";

import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { mapState, mapActions } from "vuex";
import exportFromJSON from "export-from-json";

export default {
  components: {
    vSelect,
    FeatherIcon,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState("masterData", [
      "companyItems",
      "sales",
      "banks",
      "service_types",
      "vip_types",
    ]),
  },
  created() {
    this.fetchUser();
    this.fetchCompany();
    this.fetchSaler();
    this.fetchBank();
    this.fetchServiceTypes();
    this.fetchVip();
    // useJwt
    //   .get("masterData?data=All", {})
    //   .then((response) => {
    //     this.service_types = response.data.result.ServiceType;
    //   })
    //   .finally(() => {
    //     this.$loading.hide();
    //   });
  },

  watch: {
    perPage: function (n, o) {
      this.fetchUser();
    },
    searchQuery: function (n, o) {
      if (this.searchQuery == "") {
        this.fetchUser();
      } else {
        this.isBtnSearch = false;
      }
    },
    currentPage: function (n, o) {
      this.fetchUser();
    },
    searchCompany: function (n, o) {
      // console.log(this.searchCompany);
      this.fetchUser();
    },
    searchSaler: function (n, o) {
      if (this.searchSaler !== null) {
        this.isBtnSearch = false;
      } else {
        this.isBtnSearch = true;
        this.fetchUser();
      }
    },
    filter: function (n, o) {
      if (this.filter == false) {
        this.searchSaler = null;
        this.searchCompany = null;
      }
    },
    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;
      this.fields = [];
      this.$nextTick(() => {
        // Add the component back in
        this.fields = [
          {
            key: "id",
            sortable: false,
            label: this.$i18n.t("userName"),
          },
          {
            key: "company_name",
            sortable: false,
            label: this.$i18n.t("companyName"),
          },
          {
            key: "full_name",
            label: this.$i18n.t("contactName"),
            sortable: false,
          },
          {
            key: "mobile",
            label: this.$i18n.t("phone"),
            sortable: false,
          },
          {
            key: "email",
            label: this.$i18n.t("email"),
            sortable: false,
          },
          {
            key: "user_sale_name",
            label: this.$i18n.t("saler"),
            sortable: false,
          },
          {
            key: "tmsVendorId",
            label: this.$i18n.t("Vendor ID"),
            sortable: false,
          },
          {
            key: "idFast",
            label: this.$i18n.t("FAST ID"),
            sortable: false,
          },
          {
            key: "actions",
            label: "Actions",
            thClass: "text-center",
          },
        ];

        this.renderComponent = true;
      });
    },
  },
  methods: {
    ...mapActions("masterData", [
      "fetchCompany",
      "fetchSaler",
      "fetchBank",
      "fetchServiceTypes",
      "fetchVip",
    ]),
    onSearch() {
      if (this.searchQuery) {
        this.$loading.show();
        this.fetchUser();
      }
    },
    onExportExcel() {
      this.$loading.show();
      

      useJwt
        .get("custMana", {
          params: {
            search: this.searchQuery.trim(),
            page: 1,
            pageSize: 9999,
            company: this.searchCompany ? this.searchCompany.name : "",
            saler: this.searchSaler ? this.searchSaler.code : "",
          },
        })
        .then((response) => {
          const data = response?.data?.result || [];
          const fields = JSON.parse(JSON.stringify(this.fields));
          // add tax_code tmd_id
          fields.push(...[{
            key: "tax_code",
            label: "Tax Code",
            sortable: false,
          },
          {
            key: "company_acronym",
            label: "Acronym",
            sortable: false,
          },
          {
            key: "tms_id",
            label: "TMS ID",
            sortable: false,
          }])  
          const itemNew = data.map((i) => {
            const item = {};
            fields.forEach((e) => {
              if (e.label != "Actions") {
                item[e.label] = i[e.key] || "";
              }
            });
            return item;
          });
          const exportType = exportFromJSON.types.xls;
      exportFromJSON({ data: itemNew, fileName: "customer-management", exportType });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Something went wrong, please try again",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    formatUser(value, event) {
      return (value < 10 && value > 0 ? "0" : "") + value + " User";
    },
    formatLocation(value, event) {
      return (value < 10 && value > 0 ? "0" : "") + value + " Location";
    },
    Permission(item, index, button) {
      this.currentItem = item;
      this.fetchPermission();
      this.$bvModal.show("modal-permission");
    },
    fetchPermission: function () {
      this.permisItems = [];
      useJwt
        .get(`userGroup/${this.currentItem.id}`, {})
        .then((response) => {
          this.permisItems = response.data.result;
          this.permisItems.forEach(function (i, v) {
            i.C = i.C == 1 ? true : false;
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        });
    },
    handPermission(bvModalEvt) {
      bvModalEvt.preventDefault();
      useJwt
        .put(`userGroup/${this.currentItem.id}`, {
          p: this.permisItems.filter((i) => i.C),
        })
        .then((response) => {
          this.fetchPermission();
          this.$bvModal.hide("modal-permission");
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("success"),
              text: this.$i18n.t("successfullyUpdated"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        });
    },
    handSearch() {
      this.fetchUser();
    },
    fetchUser: function () {
      useJwt
        .get("custMana", {
          params: {
            search: this.searchQuery.trim(),
            page: this.currentPage,
            pageSize: this.perPage,
            company: this.searchCompany ? this.searchCompany.name : "",
            saler: this.searchSaler ? this.searchSaler.code : "",
          },
        })
        .then((response) => {
          this.items = response.data.result;
          this.totalRows = response.data.meta.total;
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Something went wrong, please try again",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    camelCaseText(e) {
      return camelCase(e);
    },
    async handChangePass(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRulesChangePass
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            text: this.$i18n.t("notifyFormError"),
            icon: "XIcon",
            variant: "danger",
          },
        });
        return;
      }
      // var check = await useJwt.get('changepass',{params:{user:this.currentItem.ID,"password":this.changepass.old}}).then(response =>{return response.data.result;}).catch(error => {return error })
      // if (check[0].c!=1){
      //   this.$toast({component: ToastificationContent,props: {title: 'Mật khẩu cũ không chính xác!',icon: 'AlertTriangleIcon',variant: 'warning'}})
      //   return;
      // }
      if (this.changepass.newPass != this.changepass.retype) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title:
              "New password and re-entering new password are not the same!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      // if (this.changepass.new==this.changepass.old){
      //   this.$toast({component: ToastificationContent,props: {title: 'Mật khẩu mới và mật khẩu cũ giống nhau!',icon: 'AlertTriangleIcon',variant: 'warning'}})
      //   return;
      // }

      useJwt
        .put("changePassForUser", {
          id: this.currentItem.id,
          newPass: this.changepass.newPass,
        })
        .then((response) => {
          this.$bvModal.hide("modal-pass");
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("success"),
              text: this.$i18n.t("successfullyUpdated"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          // setTimeout(function(){
          //   localStorage.clear();
          //   router.push({name:'auth-login'});
          // },3000);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        });
    },
    editService() {
      this.$bvModal.show("modal-add-sale");
    },
    lockUser(item) {
      this.currentItem = item;
      useJwt
        .put(`updateStatusUser`, {
          id: this.currentItem.id,
          status: this.currentItem.status_id == 1 ? 0 : 1,
        })
        .then((response) => {
          this.fetchUser();
          this.$toast({
            component: ToastificationContent,
            props: {
              title:
                this.currentItem.status_id == 1
                  ? this.$i18n.t("Lock Successful")
                  : this.$i18n.t("Unlock Successful"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("Failed"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    ChangePas(item, index, button) {
      this.currentItem = {};
      this.currentItem = item;
      this.$bvModal.show("modal-pass");
      this.changepass.newPass = "";
      this.changepass = {};
    },
    handleOkEditSale() {
      var listRemove = [];
      for (var key of Object.keys(this.tempServiceUserID)) {
        const arrRemove = this.tempServiceUserID[key].filter(
          (val) => !this.serviceUserID[key].some(({ id }) => val.id === id)
        );
        if (arrRemove.length > 0) {
          arrRemove.map((e) =>
            listRemove.push({
              id: key,
              saleIDs: e.id,
            })
          );
        }
      }
      if (this.currentItem.tempSaleID && listRemove.length > 0) {
        listRemove.map((e) => {
          //  return axios.get(base + story + extension).then(res => res.data)
          const existsBooking = {
            status: this.$Utils.CONSTANTS.SALE_EXITS_QUO_BOOK,
            saleIds: e.saleIDs.toString(),
            customerId: this.currentItem.id || "",
            serviceTypeId: e.id,
          };
          useJwt
            .get(`/checkSalerExistsBooking`, { params: existsBooking })
            .then((response) => {
              if (response.data.result[0].FULLNAMES) {
                return this.$swal({
                  icon: "warning",
                  text: `Nhân viên Sale đấy đang phụ trách các quotation/booking còn hiệu lực Vui lòng đổi/gán lại nhân viên Sale các quotation/booking trước khi xóa`,
                  focusConfirm: false,
                  showCancelButton: true,
                  showCloseButton: true,
                  showConfirmButton: true,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.$router.push({
                      name: "user-mgmt",
                      params: {
                        serviceTypeId: e.id,
                        saleID: e.saleIDs.toString(),
                        customerId: this.currentItem.id,
                        modal: true,
                      },
                    });
                    // this.$router.push(`/admin/user-mgmt?saleID=123`);
                  }
                });
              } else {
                this.updateUser();
              }
            })
            .catch((error) => {
              return this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("approvedError"),
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
        });
      } else {
        this.updateUser();
      }
    },
    Edit(item) {
      this.currentItem = {
        idFast: "",
        idTms: "",
      };

      const jsonData = JSON.parse(item.user_sale_id);
      var arrSale = [];
      for (var key of Object.keys(jsonData)) {
        arrSale.push(jsonData[key]);
      }
      this.currentItem.id = item.id;

      this.currentItem.tmsVendorId = item.tms_vendor_id;

      this.currentItem.tempSaleID = item.user_sale_id;

      this.currentItem.IDLogin = item.id;
      this.currentItem.fullName = item.full_name;
      this.currentItem.company_name = this.companyItems.find(
        (e) => e.name == item.company_name
      );
      this.currentItem.gender_id = item.gender_id;
      this.currentItem.phone = item.mobile;
      this.currentItem.email = item.email;
      var arrSaleID = arrSale.toString().split(",");
      var res = this.sales.filter((item) => arrSaleID.includes(item.code));
      this.currentItem.saler = res;
      this.currentItem.idFast = item.fast_id;
      this.currentItem.idTms = item.tms_id;
      this.currentItem.idCard = item.id_card;
      this.currentItem.userRoot = item.user_root;
      this.currentItem.bankAccount = item.bank_account;
      this.bankName = this.banks.find((e) => e.code == item.bank_code);
      this.currentItem.dateRegister = item.created_date;
      this.currentItem.dateApproved = item.approved_date;
      this.currentItem.totalUser = item.total_user_list;
      this.currentItem.totalLocation = item.total_location;
      this.currentItem.idUserList = item.user_list_id;
      this.currentItem.customerLevelId =
        this.vip_types.find((e) => e.id == item?.customer_level_id) || "";
      this.modal_title = "Update User";
      this.$bvModal.show("modal-edit");
      const dataTemp = JSON.parse(this.currentItem.tempSaleID);
      this.services = this.service_types.filter((e) =>
        Object.keys(dataTemp).toString().includes(e.id)
      );
      // this.serviceUserID = JSON.parse(this.currentItem.tempSaleID);
      var dataService = {};
      for (var key of Object.keys(dataTemp)) {
        dataService[key] = this.sales.filter((e) =>
          dataTemp[key].toString().includes(e.id)
        );
      }
      this.tempServiceUserID = JSON.parse(JSON.stringify(dataService));

      this.serviceUserID = dataService;
    },

    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm(
        this.$i18n.t("areYouDelete") + " " + item.id + "?",

        {
          title: this.$i18n.t("deleteUser"),
          size: "sm",
          okTitle: this.$i18n.t("ok"),
          cancelTitle: this.$i18n.t("cancel"),
        }
      );
      if (res) {
        useJwt
          .delete(`custMana`, { params: { id: item.id } })
          .then((response) => {
            this.fetchUser();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("successfullyDeleted"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("failedDelete"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("required"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      const service = {};
      for (var key of Object.keys(this.serviceUserID)) {
        service[key] = this.serviceUserID[key].map((e) => e.id).toString();
      }

      const data = {
        bankAccount: this.currentItem.bankAccount?.trim(),
        bankCode: this.bankName?.code?.trim(),
        fastId: this.currentItem.idFast?.trim().toLowerCase(),
        tmsId: this.currentItem.idTms?.trim().toLowerCase(),
        tmsVendorId: this.currentItem.tmsVendorId?.trim().toLowerCase(),
        email: this.currentItem.email?.trim().toLowerCase(),
        fullName: this.currentItem.fullName.trim(),
        genderId: this.currentItem.gender_id,
        id: this.currentItem.IDLogin.trim(),
        idCard: this.currentItem.idCard?.trim(),
        idUserList: this.currentItem.idUserList,
        phone: this.currentItem.phone.trim(),
        taxCode: this.currentItem.company_name.code.trim(),
        customerLevelId: this.currentItem.customerLevelId.id,
        userSaleId: JSON.stringify(service).toString(),
      };

      useJwt
        .put(`custMana`, data)
        .then((response) => {
          if (
            response.data.result == 0 ||
            response.data.result == "emailExists"
          ) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          } else {
            this.fetchUser();
            this.$bvModal.hide("modal-edit");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("successfullyApproved"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("approvedError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateUser() {
      var listSale = this.currentItem.saler.map((e) => e.code);

      this.currentItem.saler = [];
      for (var key of Object.keys(this.serviceUserID)) {
        this.currentItem.saler = [
          ...this.currentItem.saler,
          ...this.serviceUserID[key],
        ];
      }

      this.$set(this.currentItem, "saler", [
        ...new Set(this.currentItem.saler.map((item) => item)),
      ]);

      this.$forceUpdate();

      this.$bvModal.hide("modal-add-sale");
    },
    New() {
      this.modal_title = this.$i18n.t("addNewUser");
      this.$bvModal.show("modal-add");
      this.resetForm();
      this.saler =
        this.sales.find((e) => e.name == this.userData.sale) ||
        this.sales.find((e) => e.name == this.userData.fullName);
    },
    async handleOkAdd(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRulesAdd
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            text: this.$i18n.t("notifyFormError"),
            icon: "XIcon",
            variant: "danger",
          },
        });
        return;
      }
      const data = {
        registerInfo: JSON.stringify({
          email: this.contactEmail.trim().toLowerCase(),
          phone: this.mobile.trim(),
          fullName: this.fullName.trim(),
          genderId: this.gender,
          taxCode: this.company.code.trim(),
          companyAddress: this.company.address.trim(),
          companyName: this.company.name.trim(),
          customerLevelId: this.customerLevelId?.id,
        }),
        email: this.contactEmail.trim().toLowerCase(),
        phone: this.mobile.trim(),
        fullName: this.fullName.trim(),
        genderId: this.gender,
        taxCode: this.company.code.trim(),
        companyAddress: this.company.address.trim(),
        companyName: this.company.name.trim(),
        customerLevelId: this.customerLevelId?.id,
      };

      useJwt
        .post("userList", data)
        .then((response) => {
          if (
            response.data.result == "emailExists" ||
            response.data.result == "0"
          ) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("emailExist"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          } else {
            this.fetchUser();
            this.$bvModal.hide("modal-add");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyAdded"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        });
    },
    resetForm() {
      this.gender = 1;
      this.company = {};
      this.saler = {};
      this.mobile = "";
      this.contactEmail = "";
      this.fullName = "";
      this.recordId = "";
      this.bankAccount = "";
      this.taxCode = "";
      this.userId = "";
      this.approvedDate = "";
      this.passport = "";
      this.bankName = "";
      this.registrationsDate = "";
      this.customerLevelId = "";
    },
    onSelectCompany(data) {
      this.currentItem.idFast = data.fast_id;
      this.currentItem.tmsVendorId = data.tms_id;
    },
  },

  data() {
    return {
      tempServiceUserID: {},
      serviceUserID: {},
      services: [],
      sortBy: "id",
      sortDesc: false,
      isBtnSearch: true,
      filter: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      searchCompany: null,
      searchSaler: null,
      items: [],
      changepass: {},
      permisItems: [],
      gender: 1,
      company: {},
      saler: {},
      mobile: "",
      contactEmail: "",
      fullName: "",
      recordId: "",
      bankAccount: "",
      taxCode: "",
      userId: "",
      approvedDate: "",
      passport: "",
      bankName: "",
      customerLevelId: "",
      registrationsDate: "",
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      searchQuery: "",
      modal_title: "",
      genders: this.$Utils.CONSTANTS.GENDER_A,
      bankName: "",
      currentItem: {
        idFast: "",
        idTms: "",
      },
      isLoading: false,
      perFields: [
        {
          key: "ROLE_NAME",
          sortable: false,
          label: this.$i18n.t("name"),
        },
        {
          key: "C",
          sortable: true,
          label: "#",
        },
      ],
      fields: [
        {
          key: "id",
          sortable: false,
          label: this.$i18n.t("userName"),
          tdClass: "text-left border",
          thClass: "text-center border",

          thStyle: { width: "8%" },
        },
        {
          key: "company_name",
          sortable: false,
          label: this.$i18n.t("companyName"),
          tdClass: "text-left border",
          thClass: "text-center border",
          thStyle: { width: "20%" },
        },
        {
          key: "full_name",
          label: this.$i18n.t("contactName"),
          thClass: "text-center border",

          sortable: false,
          tdClass: "text-left border",
        },
        {
          key: "mobile",
          label: this.$i18n.t("phone"),
          thClass: "text-center border",
          sortable: false,
          tdClass: "text-right border",
          thStyle: { width: "7%" },
        },
        {
          key: "email",
          label: this.$i18n.t("email"),
          thClass: "text-center border",
          sortable: false,
          tdClass: "text-left border",
        },
        {
          key: "user_sale_name",
          label: this.$i18n.t("saler"),
          thClass: "text-center border",
          tdClass: "text-left border",
          thStyle: { width: "20%" },

          sortable: false,
        },
        {
          key: "tms_vendor_id",
          label: this.$i18n.t("Vendor ID"),
          sortable: false,
          thClass: "text-center border",
          tdClass: "border",
          thStyle: { width: "7%" },
        },
        {
          key: "fast_id",
          label: this.$i18n.t("FAST ID"),
          sortable: false,
          tdClass: "border",
          thClass: "text-center border",
          thStyle: { width: "7%" },
        },
        {
          key: "actions",
          label: "Actions",
          thClass: "text-center border",
          tdClass: "actions-td-manager border",
        },
      ],
    };
  },
  beforeDestroy() {
    this.$store.commit("masterData/RESET_STATE");
  },
};
</script>

<style scoped>
.with-top-border > td {
  border-top: 2px solid black !important;
}

.tms-100 {
  max-width: 100px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.status-witing {
  background: rgba(254, 224, 0, 0.33);
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 1px;
  padding-bottom: 1px;
  border-radius: 50rem;
  font-weight: 600;
  color: #fab318;
}
.input-href {
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
  color: #00b0ec;
  cursor: pointer;
}

.btn-icon {
  cursor: pointer;
  color: #2b938c77;
}
.filter-active {
  color: #2b938c;
}

.round .multiselect__tags {
  border-radius: 1.5rem !important;
}
.gap-10 {
  gap: 10px;
}
</style>
